import { useTranslation } from 'react-i18next';

export default function ShippingSection() {
  const { t } = useTranslation();

  const shippingLines = [
    { name: 'EMS', time: '7-15 days', best: 'Brazil, USA' },
    { name: 'DHL', time: '3-7 days', best: 'Europe, UK' },
    { name: 'EUB', time: '10-20 days', best: 'Budget option' },
    { name: 'SAL', time: '15-30 days', best: 'Heavy packages' },
  ];

  return (
    <section id="shipping" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              Shipping
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
              {t('shipping_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              {t('shipping_desc')}
            </p>
            <div className="space-y-3">
              {shippingLines.map((line) => (
                <div key={line.name} className="flex items-center justify-between p-3 bg-background-50 rounded-lg border border-background-200/50">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-md bg-primary-50 flex items-center justify-center">
                      <i className="ri-truck-line w-4 h-4 flex items-center justify-center text-primary-600" />
                    </div>
                    <span className="font-medium text-sm text-foreground-900">{line.name}</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-medium text-foreground-900">{line.time}</div>
                    <div className="text-xs text-foreground-500">{line.best}</div>
                  </div>
                </div>
              ))}
            </div>
            <a
              href="/article/cssbuy-shipping"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors mt-4"
            >
              Shipping Calculator
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
          <div className="relative order-1 lg:order-2">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=assorted%20international%20shipping%20boxes%20with%20world%20map%20and%20tracking%20codes%20on%20clean%20light%20surface%20studio%20product%20photography%20soft%20light%20logistics&width=800&height=600&seq=shipping-1&orientation=landscape&nocache=true"
                alt="Shipping"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}